<mat-card appearance="outlined">
  <section>
    <mat-tab-group dynamicHeight [(selectedIndex)]="currentTab">

      <mat-tab label="Evaluator List" *ngIf="tabVisible('evaluatorList')">
        <app-evaluatorList></app-evaluatorList>
      </mat-tab>

      <mat-tab label="PCA/Index/Agency" *ngIf="tabVisible('pcaIndexAgency')">
        <app-pcaIndexAgency></app-pcaIndexAgency>
      </mat-tab>

      <mat-tab label="Proficiency Tests" *ngIf="tabVisible('proficiencyTests')">
        <app-proficiencyTests></app-proficiencyTests>
      </mat-tab>

      <mat-tab label="Specialties" *ngIf="tabVisible('specialties')">
        <app-specialtyCategory></app-specialtyCategory>
      </mat-tab>

      <mat-tab label="Surveyors" *ngIf="tabVisible('surveyors')">
        <app-surveyors></app-surveyors>
      </mat-tab>

      <mat-tab label="User List" *ngIf="tabVisible('userList')">
        <app-useradministration></app-useradministration>
      </mat-tab>

    </mat-tab-group>
  </section>
</mat-card>